import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=8c70b376"
import script from "./FileViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileViewer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports